<div class="affiliation-wrap">
  <div class="header d-flex align-items-center justify-content-between">
    <h4 class="mb-0">Ministry Affiliation</h4>
  </div>

  <div *ngIf="loading" class="loading">Loading affiliation...</div>

  <ng-container *ngIf="!loading && affiliation; else emptyState">
    <div class="ministry-card">
      <div class="cover">
        <div class="cover-img" [ngStyle]="{ 'background-image': 'url(' + (affiliation.communityCoverPhoto | ministryCoverPhoto) + '), url(/assets/church_image.jpg)' }"></div>
        <div class="cover-overlay"></div>
        <div class="profile">
          <div class="avatar-lg" [ngStyle]="{ 'background-image': 'url(' + (affiliation.communityPhoto | ministryProfilePhoto) + '), url(/assets/icon-2.jpg)' }"></div>
          <div class="identity">
            <div class="title" [title]="affiliation.communityName">{{ affiliation.communityName || 'Affiliated Ministry' }}</div>
            <div class="subtitle">
              <span *ngIf="affiliation.communityUserName">@{{ affiliation.communityUserName }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="body">
        <div class="body-toolbar">
          <div class="chips">
          <span class="chip green" *ngIf="affiliation.isAffiliated">Affiliated</span>
          <span class="chip blue" *ngIf="affiliation.communityEmail">{{ affiliation.communityEmail }}</span>
          <span class="chip orange" *ngIf="affiliation.faith?.name">Faith: {{ affiliation.faith.name }}</span>
          <span class="chip orange" *ngIf="affiliation.faithBranch?.name">Branch: {{ affiliation.faithBranch.name }}</span>
          <span class="chip orange" *ngIf="affiliation.faithDenomination?.name">Denomination: {{ affiliation.faithDenomination.name }}</span>
          </div>
          <a class="btn btn-sm btn-soft-primary" [href]="detailUrl()" target="_blank" rel="noopener">View Details</a>
        </div>

        <div class="rows mt-2">
          <div class="kv" *ngIf="faithLine()">
            <span class="k">Faith:</span>
            <span class="v">{{ faithLine() }}</span>
          </div>
          <div class="kv" *ngIf="affiliation.address?.streetAddress || affiliation.address?.googleAddress">
            <span class="k">Address:</span>
            <span class="v">{{ affiliation.address.streetAddress || affiliation.address.googleAddress }}</span>
          </div>
          <div class="kv" *ngIf="affiliation.logLine">
            <span class="k">Tagline:</span>
            <span class="v">{{ affiliation.logLine }}</span>
          </div>
          <div class="kv" *ngIf="affiliation.shortBio">
            <span class="k">Bio:</span>
            <span class="v">{{ affiliation.shortBio }}</span>
          </div>
          <div class="kv" *ngIf="affiliation.welcomeMessage">
            <span class="k">Welcome:</span>
            <span class="v">{{ affiliation.welcomeMessage }}</span>
          </div>
          <div class="kv" *ngIf="affiliation.affiliatedOn">
            <span class="k">Affiliated On:</span>
            <span class="v">{{ affiliation.affiliatedOn | date:'mediumDate' }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #emptyState>
    <div class="empty">No affiliation found.</div>
  </ng-template>
</div>
